import styles from './LoadingDashboardValue.module.css';

function LoadingCalculationValue({
    isLoading,
    children
}: {
    isLoading: boolean;
    children: JSX.Element;
}) {
    if (!isLoading) {
        return children;
    }

    return (
        <span
            className={styles.loadingNewValue}
            data-testid="calculation-value-loading"
        >
            {children}
        </span>
    );
}

// eslint-disable-next-line import/no-default-export
export default LoadingCalculationValue;
